import React from 'react';
export function Footer() {
  return <footer className="bg-cosmic-black border-t border-gold-primary border-opacity-20 py-12" data-id="element-272">
      <div className="container mx-auto px-6" data-id="element-273">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0" data-id="element-274">
          <div className="text-center md:text-left" data-id="element-275">
            <h3 className="text-2xl font-serif font-bold text-gold-light mb-2" data-id="element-276">
              LOS 12
            </h3>
            <p className="text-gray-400 text-sm" data-id="element-277">
              Doce entidades. Doce energías. Doce reinos.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-278">
            <a href="#" className="text-gray-400 hover:text-gold-light transition-colors" data-id="element-279">
              Términos y condiciones
            </a>
            <a href="#" className="text-gray-400 hover:text-gold-light transition-colors" data-id="element-280">
              Política de privacidad
            </a>
            <a href="#" className="text-gray-400 hover:text-gold-light transition-colors" data-id="element-281">
              Política de reembolsos
            </a>
            <a href="#" className="text-gray-400 hover:text-gold-light transition-colors" data-id="element-282">
              Contacto/soporte
            </a>
          </div>
        </div>

        <div className="mt-8 text-center text-gray-500 text-sm" data-id="element-283">
          © 2026 LOS 12. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}